import { SERVER_DATA_ELEMENT_ID, ServerData } from '@/ssr/utils/serverData';

// Must run before the redux store or Amplitude are created: both read these window globals.
export const readServerData = () => {
    const element = document.getElementById(SERVER_DATA_ELEMENT_ID);
    if (!element?.textContent) {
        throw new Error(`Server data block #${SERVER_DATA_ELEMENT_ID} is missing from the page`);
    }

    const { amplitudeExperiments, data, featureFlags }: ServerData = JSON.parse(element.textContent);
    window.__data = data;
    window.__amplitudeExperiments = amplitudeExperiments;
    window.__featureFlags = featureFlags;

    element.remove();
};
